import camelcaseKeys from "camelcase-keys"

export const toCamelCase = <T>(
  data: Record<string, unknown> | Record<string, unknown>[],
): T => {
  const result = camelcaseKeys(data, { deep: true })

  return result as T
}
